export const DATA_ELEM = 'mediaUploader';

export const MEDIA_UPLOADER_MULTI_CONTAINER = `${DATA_ELEM}-multiContainer`;
export const MEDIA_UPLOADER_DROP_PLACE = `${DATA_ELEM}-dropPlace`;
export const MEDIA_UPLOADER_ERRORS_CONTAINER = `${DATA_ELEM}-errorsContainer`;
export const MEDIA_UPLOADER_FILES_CONTAINER = `${DATA_ELEM}-filesContainer`;
export const MEDIA_UPLOADER_FILE = `${DATA_ELEM}-file`;
